import { FC } from "react";
import { Box, Typography } from "@mui/material";
import { AutoMode } from "@mui/icons-material";
import { LoadingPhase } from "../../shared/newLearningHelper";

type LoadingProgress = "loading" | "complete" | "error";

type Props = {
  classes: any;
  t: (key: string, opts?: any) => string;
  progress: LoadingPhase;
  progressPercent: number;
  titleText: string;
  statusText: string;
};

const LoadingState: FC<Props> = ({
  classes,
  t,
  progress,
  progressPercent,
  titleText,
  statusText,
}) => {
  const boundedProgress = Math.max(0, Math.min(100, progressPercent));
  const fillClassName = progress === "error" ? classes.progressFillError : classes.progressFill;

  return (
    <Box
      id="loading-state"
      className={classes.loadingContainer}
      role="status"
      aria-live="polite"
      aria-busy={progress === "loading"}
    >
      <div className={classes.iconWrapper}>
        <AutoMode className={classes.icon} aria-hidden />
      </div>

      <Typography component="h3" variant="h5" className={classes.title}>
        {titleText}
      </Typography>

      <div className={classes.searchingRow}>
        <div className={classes.searchingLabel} aria-hidden>
          <span>{statusText}</span>
        </div>

        <progress
          value={boundedProgress}
          max={100}
          aria-label={t("loading")}
          className={classes.progressStyle}
        />
        <div className={classes.progressTrack} aria-hidden>
          <div className={fillClassName} style={{ width: `${boundedProgress}%` }} />
        </div>
      </div>
    </Box>
  );
};

export default LoadingState;
